import { Icon56CheckCircleOutline, Icon56InfoOutline } from '@vkontakte/icons';
import { Button, Text, Title } from '@vkontakte/vkui';
import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import {
    B2B_ALLDOCUMENTS_REQUEST_BUTTON,
    B2B_ALLDOCUMENTS_REQUEST_INTERVAL,
} from 'reactApp/appHelpers/featuresHelpers/features/unpaidB2BDisableAllDocuments';
import { sendAllDocumentsUnlockRequest } from 'reactApp/modules/allDocuments/allDocuments.module';
import { getAllDocumentsAccessRequestTimer } from 'reactApp/sections/AllDocuments/helpers/allDocumentsAccessRequestTimer';
import { checkTimeInterval } from 'reactApp/sections/AllDocuments/helpers/checkTimeInterval';

import styles from './AllDocumentsDisabledPopup.css';

const AllDocumentsDisabledBizPopup = () => {
    const dispatch = useDispatch();

    const lastTimestamp = getAllDocumentsAccessRequestTimer();
    const messageSent = checkTimeInterval(lastTimestamp, B2B_ALLDOCUMENTS_REQUEST_INTERVAL);

    const handleSendAllDocsUnlockRequest = () => {
        dispatch(sendAllDocumentsUnlockRequest());
    };

    const content = useMemo(() => {
        if (messageSent) {
            return {
                icon: <Icon56CheckCircleOutline className={styles.icon} />,
                title: 'Запрос отправлен',
                description: 'Как только администратор выберет тариф — сможете пользоваться всеми функциями',
            };
        } else if (B2B_ALLDOCUMENTS_REQUEST_BUTTON) {
            return {
                icon: <Icon56InfoOutline className={styles.icon} />,
                title: 'Это — Документы',
                description: 'Редактируйте, создавайте новые, работайте вместе. Для подключения этих функций выберите тариф',
            };
        }
        return {
            icon: <Icon56InfoOutline className={styles.icon} />,
            title: 'Это — Документы',
            description: 'Редактируйте, создавайте новые, работайте вместе.\nДля подключения этих функций обратитесь\nк администратору',
        };
    }, [messageSent]);

    return (
        <div data-qa-id="alldocuments-disable-popup-content" className={styles.content}>
            {content.icon}
            <Title data-qa-id="alldocuments-disable-popup-title">{content.title}</Title>
            <Text className={styles.description}>{content.description}</Text>
            {!messageSent && B2B_ALLDOCUMENTS_REQUEST_BUTTON && (
                <Button size="l" mode="secondary" appearance="neutral" onClick={handleSendAllDocsUnlockRequest}>
                    Подключить через администратора
                </Button>
            )}
        </div>
    );
};

export default AllDocumentsDisabledBizPopup;
